import { SUBMIT } from '../../components/FlowStateElement/elementTypes';
import { OFFLINE_SAVE_FAILED, SUBMISSION_STATUS } from './constants';

export const selectIsSubmissionPending = ({ flow }) => flow.submissionStatus === SUBMISSION_STATUS.PENDING;

/** A durably queued final is complete on this device, not accepted by the server. */
export const selectIsSubmissionQueued = ({ flow }) => flow.submissionStatus === SUBMISSION_STATUS.QUEUED;

export const selectHasOfflineSaveFailed = ({ flow }) => flow.submitError?.code === OFFLINE_SAVE_FAILED;

export const selectIsSubmitLocked = (state) =>
  selectIsSubmissionPending(state) ||
  selectIsSubmissionQueued(state) ||
  state.flow.submissionStatus === SUBMISSION_STATUS.COMPLETED ||
  Object.values(state.flow.questions).some((question) => question.file && question.isLoading);

/** Nothing was saved offline, so only a new online attempt is worth submitting. */
export const selectIsSubmitBlocked = (state, isOnline = globalThis.navigator?.onLine !== false) =>
  selectIsSubmitLocked(state) || (selectHasOfflineSaveFailed(state) && !isOnline);

/** Submit shows submission errors itself; other submission paths need a separate notice. */
export const selectHasVisibleSubmit = ({ flow }) =>
  !flow.isConversational &&
  flow.currentState.elements.some((id) => flow.elements[id]?.type === SUBMIT && flow.elements[id].isVisible);
